
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiGrid extends Serenity.EntityGrid<UtentiProdottiRow, any> {
        protected getColumnsKey() { return UtentiProdottiColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiDialog; }
        protected getIdProperty() { return UtentiProdottiRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiRow.localTextPrefix; }
        protected getService() { return UtentiProdottiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}